import React from 'react';

import { PermissionComponentProps } from './PermissionComponent.types';
import { Route, RouteProps } from 'react-router-dom';
import { usePermission } from '../../../hooks';


export type PermissionRouteProps = RouteProps & PermissionComponentProps;

export const BasePermissionRoute: React.FC<PermissionRouteProps> = (props: Readonly<PermissionRouteProps>): JSX.Element | null => {

  const {
    permission,
    ...routeProps
  } = props;

  const showRoute = usePermission(permission);

  if (showRoute) {
    return (
      <Route {...routeProps} />
    );
  }
  return null;

}
BasePermissionRoute.displayName = 'PermissionRoute';
export const PermissionRoute = (BasePermissionRoute);
